/* eslint-disable */
import cx from 'classnames';
import moment from 'moment-timezone';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { NotificationManager } from 'react-notifications';

import OzComponent from '../lib/OzComponent';
import { usd, newOrder, isLoggedIn, ss, navTo, mapDispatch, distance, upperFirst, setToken, getParams, removeUrlParam } from '../utils/util';
import './Manage.css';
import Wrapper from './Wrapper';
import EditableCompany from './partials/EditableCompany';
import LocationForm from './partials/LocationForm';
import DeleteRoomForm from './partials/DeleteRoomForm';
import SimpleEscapeForm from './partials/SimpleEscapeForm';
import IntegrationForm from './partials/IntegrationForm';
import LeaderboardWidget from './partials/LeaderboardWidget';
import OzModalButton from './partials/OzModalButton';
import OzTabs from '../lib/OzTabs';
import { SITE_DOMAIN } from '../config';

import {
  fetchUser,
  listCompanies,
  updateRoom,
  addIntegration,
  pullMyData,
  addLocation,
  addEscape,
  updateLocation,
  listEscapes,
  updateEscape,
} from '../actions';


class EditLeaderboard extends Component {

  state = {};

  componentDidMount() {
    this.props.listEscapes({ room: this.props.roomId }, { local: true, silent: true })
      .then(resp => {
        this.setState({ escapes: resp.items });
      });
  }

  didUpdate() {
    return this.props.listEscapes({ room: this.props.roomId }, { local: true })
      .then(resp => {
        this.setState({ escapes: resp.items, editing: null });
      });
  }

  saveEscape(e, escapeId, values) {
    this.props.updateEscape(escapeId, values.escape)
      .then(resp => {
        if (resp.error) return;
        this.didUpdate();
      });
  }

  verify(escapeId) {
    this.props.updateEscape(escapeId, { verified: true })
      .then(resp => this.didUpdate());
  }

  unverify(escapeId) {
    this.props.updateEscape(escapeId, { verified: false })
      .then(resp => this.didUpdate());
  }

  renderEscapes() {
    let escapes = this.state.escapes;
    if (!escapes) return;
    console.log('widget escapes', escapes);

    escapes.sort((a, b) => {
      let apt = a.prettyTime || '9999:99';
      let bpt = b.prettyTime || '9999:99';
      return apt.localeCompare(bpt);
    });

    let rank = 1;
    let nodes = escapes.map(escape => {
      let r = '';
      if (escape.verified) {
        r = '#' + rank;
        rank++;
      }
      return (
        <div className="escape" key={escape.id}>
          <div className="rank">{r}</div>
          <div className="name">{escape.displayName}</div>
          <div className="time">{escape.didEscape ? escape.prettyTime : 'Did not escape'}</div>
          <div className="controls">
            <OzModalButton
              modalTitle="Edit Escape"
              show={this.state.editing == escape.id}
              onShow={() => this.setState({ editing: escape.id })}
              onHide={() => this.setState({ editing: null })}
              >
              <Button bsSize="small">Edit</Button>

              <SimpleEscapeForm
                values={escape}
                modal={true}
                errors={this.props.errors.addEscape}
                buttonText="Save"
                cancelText="Cancel"
                onSubmit={(e, values) => this.saveEscape(e, escape.id, values)}
                onCancel={() => this.setState({ editing: null })}
              />
            </OzModalButton>{' '}

            <Link to={'/e/' + escape.room.slug + '/' + escape.id}>
              <Button bsSize="small">View</Button>
            </Link>

            {escape.verified && <Button bsSize="small" onClick={() => this.unverify(escape.id)}>Un-Verify</Button>}
            {!escape.verified && <Button bsSize="small" bsStyle="primary" onClick={() => this.verify(escape.id)}><FontAwesome name="check-circle" /> Verify</Button>}
          </div>
        </div>
      );
    });

    return (
      <div className="leaderboard">
        <div className="escapes">
          {nodes}
        </div>
      </div>
    );
  }

  addEscape(e, values) {
    console.log('add escape', values);
    this.props.addEscape(values)
      .then(resp => {
        if (resp.error) return;
        this.didUpdate().then(() => this.setState({ adding: false }));
      });
  }

  render() {
    let room = this.props.room;

    return (
      <div className="EditLeaderboard">
        <div className="header">
          <div className="title">
            Manage <b>{room.name}</b> leaderboard
          </div>

          <div className="controls">
            <OzModalButton
              modalTitle="Add Escape"
              show={this.state.adding}
              onShow={() => this.setState({ adding: true })}
              onHide={() => this.setState({ adding: false })}
              >
              <Button>
                Add Escape
              </Button>

              <SimpleEscapeForm
                enterTeam
                values={{ roomId: this.props.roomId }}
                modal={true}
                errors={this.props.errors.escape}
                buttonText="Add"
                cancelText="Cancel"
                onSubmit={(e, values) => this.addEscape(e, values)}
                onCancel={() => this.setState({ adding: false })}
              />
            </OzModalButton>
          </div>
        </div>

        {this.renderEscapes()}
      </div>
    );
  }
}


class Manage extends OzComponent {

  static need = [
    ['user', fetchUser],
  ];

  state = { adding: 23815 };

  componentDidMount() {
    this.props.listCompanies({ mine: 1 });
  }

  renderCompanies() {
    let companies = this.props.companies;
    if (!companies) return;

    let nodes = companies.items.map(company => <EditableCompany
                                                 key={company.id}
                                                 companyId={company.id}
                                                 {...this.props}
                                               />);
    return (
      <div>
        {nodes}
      </div>
    );
  }

  renderLeaderboard() {
    let companies = this.props.companies;
    if (!companies) return;
    let rooms = [];

    for (let company of companies.items) {
      for (let location of company.locations) {
        for (let room of location.rooms) {
          rooms.push(room);
        }
      }
    }

    let nodes = rooms.map(room => {
      return (
        <div className="leaderboard-wrapper">
          <div className="room-info">
            <div className="room-name">Leaderboard for <b>{room.name}</b></div>
          </div>

          <div className="leaderboard-content">
            <OzTabs noUrl>
              <div tabName="Preview/Embed Widget" tabKey="preview">
                <div className="widget">
                  <div className="explanation">
                    Below is a preview leaderboard widget as it will display on your site.
                  </div>
                  <LeaderboardWidget key={room.id} roomId={room.id} />
                </div>
              </div>
              <div tabName="Manage Escapes/Times" tabKey="manage">
                <div className="edit">
                  <div className="explanation">
                    Manage and verify escapes below.
                  </div>
                  <EditLeaderboard
                    listEscapes={this.props.listEscapes}
                    updateEscape={this.props.updateEscape}
                    addEscape={this.props.addEscape}
                    errors={this.props.errors}
                    key={room.id}
                    room={room}
                    roomId={room.id}
                  />
                </div>
              </div>
            </OzTabs>
          </div>
        </div>
      );
    });

    return (
      <div className="leaderboard-section">
        <div className="blurb">
          <p><b>Your EscapeSpy leaderboards.</b> You can manage which escapes show up on your leaderboards, and add them to your site using the embed code. Each room as its own distinct leaderboard.</p>
          <p><b>Only verified escapes show on leaderboards.</b> To verify an escape, click the "Verify" button in the management box. You can reverse this action to un-verifty an escape, which will hide it from the leaderboard.</p>
        </div>
        <div className="leaderboards">
          {nodes}
        </div>
      </div>
    );
  }

  render() {
    let title = 'Manage Your Listings';
    return (
      <Wrapper className="Manage" title={title} padded>
        <Helmet>
          <title>{title}</title>
        </Helmet>

        <OzTabs>
          <div tabName="Listings" tabKey="listings">{this.renderCompanies()}</div>
          <div tabName="Leaderboard" tabKey="leaderboard">{this.renderLeaderboard()}</div>
        </OzTabs>

      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
    companies: state.list.company,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    listCompanies,
    updateRoom,
    addIntegration,
    pullMyData,
    addLocation,
    addEscape,
    updateLocation,
    listEscapes,
    updateEscape,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Manage);



/** WEBPACK FOOTER **
 ** ./src/components/Manage.js
 **/